import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for integrations
const initialState = {
  integrations: [
    {
      name: "googleanalytics",
      displayName: "Google Analytics",
      isPurchased: false,
      isUpgraded: true,
      icon: "BrandGAnalytics",
      aboutOauth: [
        "Full support of GA4 including all goals, events, and custom metrics",
        "All your Plausible data in Slack including custom metrics",
        "Facebook Ads and Google Ads integration, get updates on your campaigns straight to Slack with daily and weekly ad reports. Daily monitoring of key metrics such as ad spend will keep you on target",
        "Track position changes on your SEO with Google Search console",
        "Shopify integration to keep you updated with your store’s performance. Get Shopify reports on your specific store metrics.",
        "Daily or hourly monitoring to give you peace of mind 24/7. Enhanced by AI to learn the patterns of data driving your business",
        "Advanced report builder to give you the power to easily customize your reports to suit the exact needs of your business Support for agencies. Get agency reports for your team and clients, and manage your accounts easily in one place"
      ],
      syncHistory: {
        // lastSynced: "2023-10-01T00:00:00Z",
        // syncCount: 0,
        // syncErrors: 0,
        // data: [
        //   {
        //     date: "2023-10-15T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-11-03T00:00:00Z",
        //     status: "failed",
        //   },
        //   {
        //     date: "2023-12-09T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-12-21T00:00:00Z",
        //     status: "failed",
        //   },
        // ],
      },
      // Add more properties as needed
    },
    {
      name: "shopify" || "Shopify_dataset-",
      displayName: "Shopify",
      isPurchased: false,
      isUpgraded: true,
      icon: "BrandShopify",
      aboutOauth: [
        "Real-time synchronization of all Shopify store data including products, orders, and customers",
        "Comprehensive sales analytics with revenue tracking, conversion rates, and average order values",
        "Inventory management insights with stock alerts and product performance metrics",
        "Customer behavior analysis including purchase patterns, lifetime value, and retention metrics",
        "Marketing campaign performance tracking with ROI measurement for discounts and promotions",
        "Multi-channel sales reporting across online store, POS, and other sales channels",
        "Automated daily, weekly, and monthly reports tailored to your business KPIs"
      ],
      syncHistory: {
        // lastSynced: "2023-10-01T00:00:00Z",
        // syncCount: Math.floor(Math.random() * 10),
        // syncErrors: Math.floor(Math.random() * 5),
        // data: [
        //   {
        //     date: "2023-10-15T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-11-03T00:00:00Z",
        //     status: "failed",
        //   },
        //   {
        //     date: "2023-12-09T00:00:00Z",
        //     status: "success",
        //   },
        // ],
      },
    },
    {
      name: "meta",
      displayName: "Meta",
      isPurchased: false,
      isUpgraded: true,
      icon: "BrandMeta",
      aboutOauth: [
        "Complete Facebook and Instagram advertising performance tracking across all campaigns",
        "Detailed audience insights including demographics, interests, and behavior patterns",
        "Real-time ad spend monitoring with budget alerts and cost-per-result optimization",
        "Cross-platform attribution tracking for Facebook, Instagram, Messenger, and Audience Network",
        "Creative performance analysis to identify top-performing ad formats and content",
        "Custom conversion tracking and funnel analysis for your specific business goals",
        "Automated reporting and alerts for campaign performance and anomaly detection"
      ],
      syncHistory: {
        // lastSynced: "2023-10-01T00:00:00Z",
        // syncCount: Math.floor(Math.random() * 15),
        // syncErrors: Math.floor(Math.random() * 3),
        // data: [
        //   {
        //     date: "2023-11-25T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-11-28T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-12-01T00:00:00Z",
        //     status: "success",
        //   },
        // ],
      },

      // Add more properties as needed
    },
    {
      name: "googleads",
      displayName: "Google Ads",
      isPurchased: false,
      isUpgraded: true,
      icon: "BrandGAds",
      aboutOauth: [
        "Comprehensive Google Ads campaign performance across Search, Display, Shopping, and Video",
        "Keyword performance analysis with quality scores, impression share, and bid recommendations",
        "Conversion tracking and attribution modeling across multiple touchpoints",
        "Budget optimization insights with automated bid strategy recommendations",
        "Competitor analysis including auction insights and competitive metrics",
        "Shopping campaign product performance with feed optimization suggestions",
        "Real-time alerts for budget pacing, performance anomalies, and optimization opportunities"
      ],
      syncHistory: {
        // lastSynced: new Date(Date.now() - Math.floor(Math.random() * 20000000)),
        // syncCount: 7,
        // syncErrors: 2,
        // data: [
        //   {
        //     date: "2023-11-28T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-11-29T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-11-30T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-12-01T00:00:00Z",
        //     status: "success",
        //   },
        // ],
      },
      // Add more properties as needed
    },
    {
      name: "youtube",
      displayName: "Youtube Analytics",
      isPurchased: false,
      isUpgraded: true,
      icon: "BrandYoutube",
      aboutOauth: [
        "Full support of GA4 including all goals, events, and custom metrics",
        "All your Plausible data in Slack including custom metrics",
        "Facebook Ads and Google Ads integration, get updates on your campaigns straight to Slack with daily and weekly ad reports. Daily monitoring of key metrics such as ad spend will keep you on target",
        "Track position changes on your SEO with Google Search console",
        "Shopify integration to keep you updated with your store’s performance. Get Shopify reports on your specific store metrics.",
        "Daily or hourly monitoring to give you peace of mind 24/7. Enhanced by AI to learn the patterns of data driving your business",
        "Advanced report builder to give you the power to easily customize your reports to suit the exact needs of your business Support for agencies. Get agency reports for your team and clients, and manage your accounts easily in one place"
      ],
      syncHistory: {
        // lastSynced: "2023-10-01T00:00:00Z",
        // syncCount: 0,
        // syncErrors: 0,
        // data: [
        //   {
        //     date: "2023-10-15T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-11-03T00:00:00Z",
        //     status: "failed",
        //   },
        //   {
        //     date: "2023-12-09T00:00:00Z",
        //     status: "success",
        //   },
        //   {
        //     date: "2023-12-21T00:00:00Z",
        //     status: "failed",
        //   },
        // ],
      },
      // Add more properties as needed
    },
  ],
};

// Define a function to update the purchased status of an integration
const integrationsSlice = createSlice({
  name: "integrations",
  initialState,
  reducers: {
    purchaseIntegration(state, action) {
      const integrationIndex = state.integrations.findIndex(
        (integration) => integration.name === action.payload.name
      );
      if (integrationIndex !== -1) {
        state.integrations[integrationIndex].isPurchased = !state.integrations[integrationIndex].isPurchased;
        // Update other properties as needed
      }
    },

  },
});

export const { purchaseIntegration } = integrationsSlice.actions;
export default integrationsSlice.reducer;

